const pattern = {
    // http://emailregex.com/
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    url: new RegExp(
        '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
        'i'
    ),
    hex: /^#?([a-f0-9]+)$/i,
    IDcard: /^(([0-9]{14}|[0-9]{17})[0-9X]|[A-Z][0-9]{6}(\([0-9]\)|[0-9])|[0-9]{8}|[A-Z][12][0-9]{8})$/, // 大陆，香港，澳门，台湾
    phone: /^(((0[0-9]{2,3}[-]?)?([2-9][0-9]{6,7})+([-]?[0-9]{1,4})?)|(\d{11}))$/
};

const types = {
    number(value) {
        /* eslint-disable-next-line */
        if (isNaN(value) || Array.isArray(value)) {
            return false;
        }
        // 只允许数字和输入的数字
        return typeof value === 'number' || typeof value === 'string';
    },
    integer(value) {
        return types.number(value) && parseInt(+value, 10) === +value;
    },
    positive(value) {
        return types.number(value) && +value > 0;
    },
    positiveInteger(value) {
        return types.number(value) && parseInt(+value, 10) === +value && +value > 0;
    },
    float(value) {
        return types.number(value) && !types.integer(value);
    },
    array(value) {
        return Array.isArray(value);
    },
    string(value) {
        return typeof value === 'string';
    },
    regexp(value) {
        if (value instanceof RegExp) {
            return true;
        }
        try {
            return !!new RegExp(value);
        } catch (e) {
            return false;
        }
    },
    date(value) {
        return Object.prototype.toString.call(value) === '[object Date]';
    },
    object(value) {
        return Object.prototype.toString.call(value) === '[object Object]';
    },
    method(value) {
        return typeof value === 'function';
    },
    email(value) {
        return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
    },
    url(value) {
        return typeof value === 'string' && !!value.match(pattern.url);
    },
    hex(value) {
        return typeof value === 'string' && !!value.match(pattern.hex);
    },
    idcard(value) {
        return typeof value === 'string' && pattern.IDcard.test(value);
    },
    phone(value) {
        return typeof value === 'string' && pattern.phone.test(value);
    },
    bool(value) {
        return typeof value === 'boolean';
    },
    undefinedOrNull(value) {
        return value === undefined || value === null;
    },
    empty(value) {
        return types.undefinedOrNull(value) || value === '';
    },
    json(value) {
        if (typeof value !== 'string') {
            return false;
        }
        try {
            const parseValue = JSON.parse(value);
            return typeof parseValue === 'object';
        } catch (e) {
            return false;
        }
    }
};

export default types;
